<template>
  <div>
    <input class="cropper-input" type="file" ref="file" @change="onLoadImage" accept="image/png, image/jpeg" />
    <div class="cropper-wrapper">
      <button class="btn is-primary cropper-file-open" type="button" @click="onFileOpen">Select File</button>
      <cropper class="cropper" ref="cropper" :src="image.src" @change="onCropChange" :canvas="{height: 150}"
        :stencil-props="{minAspectRatio: 1/1, maxAspectRatio: 2/1}"  
        :default-position="{top: 0, left: 0}" :default-size="defaultStencilSize" />
    </div>
  </div>
</template>

<script>
import Button from '../ui/inputs/Button'
import TextInput from '../ui/inputs/TextInput'
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
  components: {
    'rp-button': Button,
    'rp-textinput': TextInput,
    'cropper': Cropper
  },

  props: {
    value: Object
  },

  data() {
    return {
      image: {
        src: null,
        type: null,
      }
    }
  },

  mounted() {
    if (this.value.sourceUrl && this.value.sourceUrl !== "") {
      this.image.src = this.value.sourceUrl
    }
  },

  computed: {
    dataUrl: {
      get() {
        return this.value.dataUrl
      },
      set(value) {
        this.$set(this.value, "dataUrl", value)
      }
    }
  },

  methods: {
    onCropChange() {
      this.dataUrl = this.$refs.cropper.getResult().canvas.toDataURL()
    },

    onFileOpen() {
      this.$refs.file.click()
    },

    onLoadImage({target}) {
      const files = target.files
      if (files && files[0]) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src)
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = {
            src: URL.createObjectURL(files[0])
          };
        };

        reader.readAsArrayBuffer(files[0]);
      }
    },

    defaultStencilSize({imageSize, visibleArea}) {
			return {
				width: (visibleArea || imageSize).width,
				height: (visibleArea || imageSize).height,
			};
		}
  }
}
</script>

<style lang="sass">
.cropper-input
  display: none

.cropper-wrapper
  position: relative

.cropper-file-open
  position: absolute;
  top: -10px;
  left: 10px;	
  z-index: 1;
  opacity: 0.8;

.cropper
  height: 200px;
  width: 400px;
  background: #DDD;
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/ImageCropper.vue